import { render, staticRenderFns } from "./Registerview.vue?vue&type=template&id=3bbdc522"
import script from "./Registerview.vue?vue&type=script&lang=js"
export * from "./Registerview.vue?vue&type=script&lang=js"
import style0 from "./Registerview.vue?vue&type=style&index=0&id=3bbdc522&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports